import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import UserPrompt from '../UserPrompt';
import { ACTIVATE_ERROR_CODES } from '../../lib/apiErrorCodes';
import {
  MainBlock,
  TitleBlock,
  BodyBlock,
  InputBlock,
  InputTitle,
  InputBody,
  InputWrapper,
  Input,
  Message,
} from './styles/ActivationPageStyles';
import { UpdateButton } from '../../styles/common/Dialog';
import { ReactComponent as ServiceLogo } from '../../images/common/logo_OPTiM-taglet.svg';

const ActivationPage = ({
  checkActivationCode,
  onClickActivate,
  onChangeInput,
  formatError,
  hasError,
  errorCode,
  activationCode,
}) => {
  const error = ACTIVATE_ERROR_CODES.indexOf(errorCode) !== -1;
  const messageId = `activation.message.error.${
    (error && errorCode) || 'others'
  }`;
  return (
    <MainBlock className="ActivationPage">
      <UserPrompt />
      <TitleBlock>
        <ServiceLogo style={{ width: '150px' }} />
      </TitleBlock>
      <BodyBlock>
        <InputBlock>
          <InputTitle>
            <FormattedMessage id="activation.input.title" />
          </InputTitle>
          <InputBody>
            <InputWrapper>
              <Input
                id="InputActivationCode"
                type="text"
                value={activationCode}
                error={formatError}
                onChange={e => onChangeInput(e.target.value)}
              />
              {errorCode && (
                <Message>
                  <FormattedMessage id={messageId} />
                </Message>
              )}
            </InputWrapper>
            <UpdateButton
              id="ActivateButton"
              onClick={() => {
                if (formatError || hasError) {
                  checkActivationCode();
                } else {
                  onClickActivate();
                }
              }}
            >
              <FormattedMessage id="activation.input.button" />
            </UpdateButton>
          </InputBody>
        </InputBlock>
      </BodyBlock>
    </MainBlock>
  );
};

ActivationPage.propTypes = {
  checkActivationCode: PropTypes.func.isRequired,
  onClickActivate: PropTypes.func.isRequired,
  onChangeInput: PropTypes.func.isRequired,
  formatError: PropTypes.bool.isRequired,
  hasError: PropTypes.bool.isRequired,
  activationCode: PropTypes.string.isRequired,
  errorCode: PropTypes.string.isRequired,
};

export default ActivationPage;
